/**
 * No-op provider for platforms with no health store (web, unsupported OS, and the
 * Node unit-test env). Keeps callers branch-free: `isAvailable()` is false, the
 * connect affordance hides, and reads resolve empty. Shared by the base and web
 * platform entrypoints so the "unavailable" behavior lives in exactly one place
 * (a plain `.ts` name that never recurses under Metro's platform resolution).
 */
import {
  BodyMeasurementSample,
  HealthDateRange,
  HealthPermissionStatus,
  HealthProvider,
  HealthScope,
  RecordedSessionSample,
} from './health-provider.types';

class UnavailableHealthProvider implements HealthProvider {
  readonly source = null;

  isAvailable(): boolean {
    return false;
  }

  async getPermissionStatus(
    _scopes: HealthScope[],
  ): Promise<HealthPermissionStatus> {
    return HealthPermissionStatus.UNAVAILABLE;
  }

  async requestPermissions(
    _scopes: HealthScope[],
  ): Promise<HealthPermissionStatus> {
    return HealthPermissionStatus.UNAVAILABLE;
  }

  async openSettings(): Promise<void> {}

  async readWorkoutSessions(
    _range: HealthDateRange,
  ): Promise<RecordedSessionSample[]> {
    return [];
  }

  async readBodyMeasurements(
    _range: HealthDateRange,
  ): Promise<BodyMeasurementSample[]> {
    return [];
  }
}

export const unavailableHealthProvider: HealthProvider =
  new UnavailableHealthProvider();
